export default "__VITE_ASSET__eCJHfHTr__"